/*
  Sticky Johnson surf guides: shared behaviour for every [data-sjg] root
  (sections/surf-guide-article.liquid and sections/sj-wax-guide.liquid).
  - The short version ([data-sjg-ritual]): tappable steps drive the animation; play runs them through.
  - Board-type tabs ([data-sjg-types]) with a sliding glider; without JS every panel shows stacked.
  - Contents rail ([data-sjg-rail]): open beside the text on desktop, a tap-to-open panel below 990px,
    and it marks the chapter ([data-sjg-spy]) you're reading.
  - Entrances: each chapter's parts blur in, staggered, but only for things still below the fold,
    never under reduced motion, and never left hidden.
*/
(function () {
  function init(root) {
    if (root.__sjg) return;
    root.__sjg = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;

    /* the short version: each step builds the animation one stage further; the play button runs them through */

    Array.prototype.forEach.call(root.querySelectorAll('[data-sjg-ritual]'), function (rit) {
      var svg = rit.querySelector('.sjg-board__svg');
      if (!svg) return;
      var btns = Array.prototype.slice.call(rit.querySelectorAll('.sjg-step'));
      var n = btns.length;
      var labels = (rit.getAttribute('data-labels') || '').split('|');
      var txt = { tap: rit.getAttribute('data-tap') || '', watch: rit.getAttribute('data-watch') || '', replay: rit.getAttribute('data-replay') || '', pause: rit.getAttribute('data-pause') || '' };
      var cap = rit.querySelector('[data-sjg-cap]');
      var bar = rit.querySelector('.sjg-board__bar i');
      var done = rit.querySelector('[data-sjg-done]');
      var play = rit.querySelector('[data-sjg-play]');
      var playLabel = rit.querySelector('[data-sjg-play-label]');
      var stage = 0, timer = null, autoplayed = false;
      function stageFor(s) { return n ? Math.round(s * 5 / n) : 0; }
      function setStage(s) {
        stage = s;
        var v = stageFor(s);
        for (var k = 1; k <= 5; k++) {
          svg.classList.toggle('is-s' + k, k <= v);
          svg.classList.toggle('is-cur' + k, k === v);
        }
        btns.forEach(function (b, i) {
          b.setAttribute('aria-pressed', i < s ? 'true' : 'false');
          b.classList.toggle('is-cur', i === s - 1);
        });
        cap.textContent = v ? (labels[v - 1] || '') : txt.tap;
        bar.style.transform = 'scaleX(' + (n ? s / n : 0) + ')';
        if (done) done.hidden = s < n;
        if (!timer) playLabel.textContent = s >= n ? txt.replay : txt.watch;
      }
      function stop() {
        clearInterval(timer); timer = null;
        play.classList.remove('is-playing');
        play.setAttribute('aria-label', txt.watch);
        playLabel.textContent = stage >= n ? txt.replay : txt.watch;
      }
      function start() {
        if (stage >= n) setStage(0);
        play.classList.add('is-playing');
        play.setAttribute('aria-label', txt.pause);
        playLabel.textContent = txt.pause;
        timer = setInterval(function () { setStage(stage + 1); if (stage >= n) stop(); }, 1500);
        setStage(stage + 1);
      }
      play.addEventListener('click', function () { timer ? stop() : start(); });
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { stop(); setStage(stage === i + 1 ? i : i + 1); });
      });
      if (!reduce && hasIO) {
        new IntersectionObserver(function (entries, io) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !autoplayed && stage === 0) { autoplayed = true; io.disconnect(); setTimeout(start, 500); }
          });
        }, { threshold: 0.6 }).observe(svg);
      }
      setStage(0);
    });

    /* board types: tabs with a sliding glider once JS runs; without JS every panel shows stacked */
    var types = root.querySelector('[data-sjg-types]');
    if (types) {
      var tabs = Array.prototype.slice.call(types.querySelectorAll('[role="tab"]'));
      var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
      var glider = types.querySelector('.sjg-tab-glider');
      function glide(t) {
        if (!glider || !t) return;
        glider.style.transform = 'translateX(' + t.offsetLeft + 'px) scaleX(' + (t.offsetWidth / 100) + ')';
      }
      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var on = j === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (panels[j]) panels[j].hidden = !on;
        });
        glide(tabs[i]);
        if (focus) tabs[i].focus();
      }
      types.classList.add('is-tabbed');
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, j = i;
          if (k === 'ArrowRight') j = (i + 1) % tabs.length;
          else if (k === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
          else if (k === 'Home') j = 0;
          else if (k === 'End') j = tabs.length - 1;
          else return;
          e.preventDefault(); select(j, true);
        });
      });
      var hash = (location.hash || '').replace('#', '');
      var startTab = 0;
      tabs.forEach(function (t, i) { if (t.getAttribute('aria-controls') === 'sjg-type-' + hash) startTab = i; });
      select(startTab);
      window.addEventListener('resize', function () {
        glide(tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0]);
      });
    }

    /* contents: always open beside the text on desktop, a tap-to-open panel on phones and tablets */
    var rail = root.querySelector('[data-sjg-rail]');
    if (rail) {
      var desk = window.matchMedia('(min-width: 990px)');
      function fitRail() { rail.open = desk.matches; }
      fitRail();
      if (desk.addEventListener) desk.addEventListener('change', fitRail);
      rail.addEventListener('toggle', function () { if (desk.matches && !rail.open) rail.open = true; });
      rail.addEventListener('click', function (e) { if (e.target.closest('.sjg-rail__a') && !desk.matches) rail.open = false; });
    }

    /* contents rail: mark the chapter you're reading */
    var links = Array.prototype.slice.call(root.querySelectorAll('.sjg-rail__a'));
    var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-sjg-spy]'));
    if (hasIO && links.length && chapters.length) {
      var current = null;
      var spy = new IntersectionObserver(function () {
        var line = window.innerHeight * 0.3, pick = chapters[0];
        chapters.forEach(function (c) { if (c.getBoundingClientRect().top <= line) pick = c; });
        if (pick === current) return;
        current = pick;
        links.forEach(function (a) {
          var on = a.getAttribute('href') === '#' + pick.id;
          a.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
      chapters.forEach(function (c) { spy.observe(c); });
    }

    /* entrances: heading, then text, then picture, staggered; only for things still below the fold */
    if (!reduce && hasIO) {
      var items = [];
      chapters.forEach(function (c) {
        if (c.classList.contains('sjg-short')) return;
        var kids = Array.prototype.slice.call(c.children);
        kids.forEach(function (k, i) {
          if (k.getBoundingClientRect().top < window.innerHeight) return;
          k.classList.add('sjg-r', 'is-wait');
          k.style.setProperty('--d', Math.min(i, 4) * 70 + 'ms');
          items.push(k);
        });
      });
      var rev = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.remove('is-wait');
          rev.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
      items.forEach(function (k) { rev.observe(k); });
      /* belt and braces: never leave anything hidden */
      setTimeout(function () { items.forEach(function (k) { if (k.getBoundingClientRect().top < window.innerHeight * 2) k.classList.remove('is-wait'); }); }, 4000);
    }
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-sjg]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
